import { useCallback, useMemo } from 'react';
import { builtInViews } from '../data/savedViews';
import { reportStorageKey } from './storageKeys';
import { usePersistentState } from './usePersistentState';

// Custom views live in this browser, per camp. Per account would need storage on the server.
export function useSavedViews(campCode) {
  const [custom, setCustom] = usePersistentState(reportStorageKey(campCode, 'savedViews'), []);
  const [activeId, setActiveId] = usePersistentState(reportStorageKey(campCode, 'activeView'), builtInViews[0].id);

  const all = useMemo(() => [...builtInViews, ...custom], [custom]);
  const activeView = all.find(v => v.id === activeId) ?? builtInViews[0];

  const saveView = useCallback(
    (name, state) => {
      const view = { id: `view-${Date.now()}`, name, state };
      setCustom(prev => [...prev, view]);
      setActiveId(view.id);
      return view;
    },
    [setCustom, setActiveId]
  );

  const updateView = useCallback(
    (id, state) => setCustom(prev => prev.map(v => (v.id === id ? { ...v, state } : v))),
    [setCustom]
  );

  const deleteView = useCallback(
    id => {
      setCustom(prev => prev.filter(v => v.id !== id));
      if (activeId === id) setActiveId(builtInViews[0].id);
    },
    [setCustom, activeId, setActiveId]
  );

  return { all, builtIn: builtInViews, custom, activeView, setActiveId, saveView, updateView, deleteView };
}
